/**
 * Returns the decimal separator for the user's locale. Examples:
 *   - Returns . for English
 *   - Returns , for Swedish
 */
export const getDecimalSeparator = () => {
  const value = 1.1;
  return value.toLocaleString().substring(1, 2);
};
